import {Component, Host, h, Event, EventEmitter, State, Prop} from '@stencil/core';
import {
  UpgradeToManagerUserDocument,
  UpgradeToManagerUserMutation,
  UpgradeToManagerUserMutationVariables
} from "../../graphql/generated";
import {ApolloClient} from "@apollo/client";

@Component({
  tag: 'snap-sign-in-form',
  styleUrl: 'snap-sign-in-form.scss',
  scoped: true,
})
export class SnapSignInForm {
  @Prop({ reflect: true }) inModal = false

  @State() schoolOptions = []
  @State() selectedOptions = { school : '', tool : ''}
  @State() nextBtnDisabled = true

  @Event({ eventName: 'snap-sign-in-form-closed', bubbles: true, composed: true }) snapSigninFormClosed: EventEmitter<void>

  private client: ApolloClient<any> = null

  private schoolsEndpoint = 'https://yxytphiqj5.execute-api.us-east-1.amazonaws.com/api/home/allschools'

  private schools = []

  private manageToolOptions = [
    {
      name: 'AD Assist',
      selected: false,
    },
    {
      name: 'Registration',
      selected: false,
    },
    {
      name: 'Control Panel',
      selected: false,
    },
  ]

  componentWillLoad() {
    this.fetchSchools()
    this.client = window.__SNAP_APOLLO_CLIENT__
  }

  async fetchSchools() {
    try {
      const response = await fetch(this.schoolsEndpoint)
      const result = await response.json()
      this.schools = result.schools
      this.schoolOptions = this.schools.map(item => {
        return {
          name: item.schoolName,
          selected: false
        }
      })
    }
    catch (error) {
      console.log(error)
    }
  }

  schoolSearchUpdated(e) {
    let result = ''

    this.schoolOptions.some( item => {
      if (item.name === e.detail.value.trim()) {
        result = item.name
        return true
      }
    })

    this.selectedOptions['school'] = result
    this.enableNextBtn()
  }

  selectMenuUpdated(e) {
    let result = ''
    e.detail.some( item => {
      if (item.selected) {
        result = item.name
        return true
      }
    })

    this.selectedOptions['tool'] = result
    this.enableNextBtn()
  }

  enableNextBtn() {
    let flag = true

    Object.entries(this.selectedOptions).map(item => {
      if (!item[1]) flag = false
    })

    this.nextBtnDisabled = !flag
  }

  async nextBtnClick() {
    if (this.nextBtnDisabled) return

    try {
      const res = await this.client.mutate<UpgradeToManagerUserMutation, UpgradeToManagerUserMutationVariables >({ mutation: UpgradeToManagerUserDocument})
      console.log(res)
    }
    catch (e) {
      console.log(e)
    }

    if (this.selectedOptions.tool === 'Control Panel') {
      window.open("https://controlpanel.8to18.com")
    }
    else {
      let result = ''
      this.schools.some( item => {
        if (item.schoolName === this.selectedOptions.school) {
          result = item.path
          return true
        }
      })

      if (this.selectedOptions.tool === 'Registration') {
        window.open(`https://${result}.8to18.com`)
      }
      else {
        window.open(`https://${result}.assist.8to18.com`)
      }
    }

    this.snapSigninFormClosed.emit()
  }

  onCloseBtnHandler() {
    this.snapSigninFormClosed.emit()
  }

  render() {
    return (
      <Host>
        <div class="sign-in-manage">
          {!this.inModal &&
            <div class="sign-in-manage-backdrop"></div>
          }
          <div class="sign-in-manage-container">
            <snap-icon class="close-icon" icon="x-solid" size="md" color="#64748B" onClick={() => {this.onCloseBtnHandler()}}/>
            <h1>Sign in to <span>Snap! Manage</span></h1>

            <div class="school-search-label">School or Organization</div>
            <snap-search
              _id="snap-search"
              options={this.schoolOptions}
              class="school-search"
              placeholder="e.g., Snapton High"
              onSnap-search-input={(e) => {this.schoolSearchUpdated(e)}}
              onSnap-search-change={(e) => {this.schoolSearchUpdated(e)}}
            />

            <snap-select-menu
              modal-type="fullscreen"
              selectMenuOptions={this.manageToolOptions}
              label="Snap! Manage Tool"
              modal-title="Snap! Manage Tool"
              placeholder="Select Tool"
              class="select-menu"
              onSnap-select-menu-updated={(e) => {this.selectMenuUpdated(e)}}
            />

            <div class="sign-in-manage-footer">
              <div class="btn-wrapper">
                <snap-button
                  variant="primary"
                  fullWidth={true}
                  disabled={this.nextBtnDisabled}
                  onClick={() => {this.nextBtnClick()}}
                >
                  Next
                </snap-button>
              </div>
            </div>
          </div>
        </div>
      </Host>
    )
  }
}
